// extracted by mini-css-extract-plugin
export default {"smile":"QpW6j","text":"bXcnZ"};